'use strict';

import React from 'react';
import WarningAmber from '@mui/icons-material/WarningAmber';
import Science from '@mui/icons-material/Science';
import Biotech from '@mui/icons-material/Biotech';
import ShowChart from '@mui/icons-material/ShowChart';
import Medication from '@mui/icons-material/Medication';
import TravelExplore from '@mui/icons-material/TravelExplore';
import HelpOutline from '@mui/icons-material/HelpOutline';

const sx = { fontSize: 'inherit', color: 'inherit', display: 'block' };

export const STUDY_GOAL_ICONS = {
	toxicology: <WarningAmber sx={sx} />,
	moa: <Science sx={sx} />,
	'biomarker-discovery': <Biotech sx={sx} />,
	'efficacy-pharmacodynamic': <ShowChart sx={sx} />,
	'metabolism-pk': <Medication sx={sx} />,
	'microbiome-host': <Biotech sx={sx} />,
	exploratory: <TravelExplore sx={sx} />,
	other: <HelpOutline sx={sx} />,
};
